import { render, staticRenderFns } from "./PettyView.vue?vue&type=template&id=61eeb9fa"
import script from "./PettyView.vue?vue&type=script&lang=js"
export * from "./PettyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports